import React from 'react';
import Icon from '../../common/icons/Icon';
import { TIERS_CHOOSE_WINBACK, TIERS_CHOOSE } from '../../../constants/Copy';
import history from '../../../history';
import { TierFeatures, TVGemistUnlimitedAccess } from '../../../constants/TierFeatures';
import TierFeatureLoader from './loaders/TierFeatureLoader';
import { TIER_FEATURE_IDS, TIER_IDS } from '../../../constants/Tiers';

export function renderTierFeature({ featureId, tierId, showTiers, isSavodExperiment }) {
	return (
		<div className="tierB-feature" key={featureId}>
			<div className="tierB-feature__title">
				{featureId === TIER_FEATURE_IDS.UNLIMITED_ACCESS && tierId === TIER_IDS.FREE
					? TVGemistUnlimitedAccess
					: TierFeatures[featureId].title}
				{featureId === TIER_FEATURE_IDS.SCREENS_AT_ONCE && isSavodExperiment && '*'}
			</div>
			{showTiers ? (
				<div className="tierB-feature__value">
					{renderTierFeatureIconAnimated(
						featureId === TIER_FEATURE_IDS.UNLIMITED_ACCESS && tierId === TIER_IDS.FREE
							? true
							: TierFeatures[featureId].values[tierId]
					)}
				</div>
			) : (
				<TierFeatureLoader tierFeatureLength={1} />
			)}
		</div>
	);
}

export function renderTierFeatureIconAnimated(value) {
	return typeof value === 'number' ? (
		<div className={`animated-number animated-number--${value}`}>
			<div className="animated-number__item">4</div>
			<div className="animated-number__item">2</div>
			<div className="animated-number__item">1</div>
		</div>
	) : (
		<div className={`animated-icon animated-icon--${value === true ? 'check' : 'cross'}`}>
			<div className="animated-icon__item">
				<Icon
					className="tier-feature__icon tier-feature__icon--checkmark"
					name="checkmark"
					viewBox="0 1 20 25"
				/>
			</div>
			<div className="animated-icon__item">
				<Icon
					className="tier-feature__icon tier-feature__icon--times"
					name="times"
					viewBox="0 1 20 25"
				/>
			</div>
		</div>
	);
}

export function getProceedText({ isPromo = true, title }) {
	return isPromo ? `${TIERS_CHOOSE} ${title}` : `${title} ${TIERS_CHOOSE_WINBACK}`;
}

export function proceedToPushUrl(proceedUrl) {
	history.push(proceedUrl);
}
